<script setup>
import { inject, onMounted } from 'vue';
import LoginContainer from '@/components/Auth/LoginContainer';
import axios from 'axios';
import { router } from '@inertiajs/vue3';
import { useToast } from 'vue-toastification';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';
import { trans } from 'laravel-vue-i18n';

const toast = useToast();
const { locale } = storeToRefs(useUserStore());

const props = defineProps({
    errors: {
        type: Object,
        default: _ => ({})
    }
});

const user = {
    email: '',
    password: '',
    code: ''
};

const getError = selector => (props.errors[selector] || null);

onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search);
    user.code = urlParams.get('code');
});

const isLoading = inject('isLoading');
const login = async () => {
    if (!isLoading.value) {
        await axios.get('/sanctum/csrf-cookie');
        const payload = {
            ...user,
            locale: locale.value
        };
        axios.post('/login', payload)
            .then(({ data }) => {
                router.visit(data?.redirect || '/');
            }).catch(() => {
                console.error('Login failed');
            });
    }
};

const navigateToForgotPassword = () => {
    router.visit('/forgot-password');
};

const disablePaste = (event) => {
    event.preventDefault();
    toast.clear();
    toast.error(trans('auth.login.paste_disabled'));
};
</script>
<template>
<LoginContainer>
    <template #title>{{ $t('auth.login.sign_in') }}</template>
    <form class="flex flex-col gap-3" @submit.prevent="login">
        <StyledInput
            v-model="user.email"
            type="email"
            name="email"
            variant="outlined"
            color="#375475"
            :error-message="getError('email')"
            :placeholder="$t('label.email')"
            :label="$t('label.email')" />
        <StyledPassword
            v-model="user.password"
            class="password"
            variant="outlined"
            color="#375475"
            :error-message="getError('password')"
            name="password"
            placeholder="******************"
            :label="$t('label.password')"
            @paste="disablePaste" />
        <StyledButton
            type="submit"
            color="#375475"
            variant="flat"
            rounded="lg"
            class="!normal-case mb-1 mt-1">
            {{ $t('auth.login.sign_in') }}
        </StyledButton>
    </form>
    <div class="flex justify-end">
        <a
            href="#"
            class="text-[13px] font-medium text-[#375475] hover:text-[#4a6d93]"
            @click="navigateToForgotPassword">{{ $t('auth.login.forgot_password') }}</a>
    </div>
</LoginContainer>
</template>

